<router-outlet></router-outlet>
<div *ngIf="!(oidcSecurityService.isAuthenticated() | async)"
     style="
      position: absolute;
      top: 0;
      left: 0;
      background-color: white;
      z-index: 1000;"
     class="full-screen"></div>
